import { SAVR_USER_INFO, DELETE_USER_INFO } from '../action_types'
import { SPRemove, SPGet, SPSet } from '../../utils/spUtils'

export const createSaveUserInfoAction = (value) => {
    SPSet("token", value.token)
    SPSet('isLogin', true)
    SPSet('email', value.email)
    SPSet('useName', value.useName)
    SPSet('password', value.password)
    return { type: SAVR_USER_INFO, date: value }

}
//退出需要的redux
export const createDeletUserInfoAction = () => {
    SPRemove("token")
    return { type: DELETE_USER_INFO }

}
